import React, {ReactElement} from "react";

import FastFactsStacked from "../fast-facts-stacked/FastFactsStacked";
import FastFactsColumns from "../fast-facts-columns/FastFactsColumns";
import {ImageObject} from "../../image/Image";
import {CTA} from "../../buttons/cta-button/CTAButton";

const FastFactCollection = (
  props: Queries.FastFactCollectionFragmentFragment
): ReactElement => {
  const {facts, image, layout, title} = props;

  if (layout === "columns") {
    const firstThreeFacts = facts != null ? facts.slice(0, 3) : [];

    return (
      <FastFactsColumns
        leftBgImage={firstThreeFacts[0]?.backgroundImage as ImageObject}
        leftLogo={firstThreeFacts[0]?.logo as ImageObject}
        leftEyebrow={firstThreeFacts[0]?.eyebrow!}
        leftHeadline={firstThreeFacts[0]?.headline!}
        leftHeadlineTrailing={firstThreeFacts[0]?.headlineTrailing!}
        leftCopy={firstThreeFacts[0]?.body?.body!}
        leftCta={firstThreeFacts[0]?.cta as CTA}
        leftCaption={firstThreeFacts[0]?.caption!}
        middleBgImage={firstThreeFacts[1]?.backgroundImage as ImageObject}
        middleLogo={firstThreeFacts[1]?.logo as ImageObject}
        middleEyebrow={firstThreeFacts[1]?.eyebrow!}
        middleHeadline={firstThreeFacts[1]?.headline!}
        middleHeadlineTrailing={firstThreeFacts[1]?.headlineTrailing!}
        middleCopy={firstThreeFacts[1]?.body?.body!}
        middleCta={firstThreeFacts[1]?.cta as CTA}
        middleCaption={firstThreeFacts[1]?.caption!}
        rightBgImage={firstThreeFacts[2]?.backgroundImage as ImageObject}
        rightLogo={firstThreeFacts[2]?.logo as ImageObject}
        rightEyebrow={firstThreeFacts[2]?.eyebrow!}
        rightHeadline={firstThreeFacts[2]?.headline!}
        rightHeadlineTrailing={firstThreeFacts[2]?.headlineTrailing!}
        rightCopy={firstThreeFacts[2]?.body?.body!}
        rightCta={firstThreeFacts[2]?.cta as CTA}
        rightCaption={firstThreeFacts[2]?.caption!}
      />
    );
  }

  return (
    <FastFactsStacked
      facts={facts as Array<Queries.FastFactFragmentFragment>}
      image={image as ImageObject}
      title={title!}
    />
  );
};

export default FastFactCollection;
